import {observer} from "mobx-react";
import {useStores} from "../../../../hooks";
import {useTranslation} from "react-i18next";
import {FadeInOutVertical} from "../../../../components/Animated";
import style from "../../style.module.sass";
import styles from "../../../menu/components/modifiersModal/style.module.sass";
import {useEffect} from "react";
import {
    CompanyBankAccountRequisites,
    PaymentProviderType,
    RecipientRussianIPCard,
    RecipientRussianOOOCard,
    RecipientType
} from "../../../../services/order/models";
import {changeEventHandlerDecorator} from "../../../../components/libs";
import {PaperBlock} from "../../../../components/paperBlock";
import SmallGreyText from "components/titles/SmallGreyTitle";
import applePayIcon from "./assets/applePayIcon.png";
import googlePayIcon from "./assets/googlePayIcon.png";
import sbpIcon from "./assets/sbp.svg";


const PaymentDetailsBlock = () => {

    const {checkoutStore, menuStore} = useStores();
    const {t} = useTranslation(["general", "cart"]);
    const paymentSettings = menuStore.menu.data.paymentSettings;

    const hasCloudpayments = paymentSettings[PaymentProviderType.cloudpayments]?.isEnabled;
    const hasSBP = paymentSettings[PaymentProviderType.sbpTochka]?.isEnabled;

    const organizationBranchId = menuStore?.menu?.organizationBranchId
    // disable for colba
    const disabledBlockForBranches = [317]

    useEffect(() => {
        const enabled = Object.values(paymentSettings).filter((v) => v.isEnabled);
        if (enabled.length > 0) {
            checkoutStore.setPaymentType(enabled[0].type);
        }
    }, []);

    useEffect(() => {
        checkoutStore.setIsReadyToSubmit(checkoutStore.validatePaymentDetails() && checkoutStore.validateDeliveryDetails());

    }, [checkoutStore.paymentDetails])


    useEffect(() => {
        if (checkoutStore.paymentType === PaymentProviderType.toBankCard) {
            checkoutStore.setPaymentDetails({
                type: PaymentProviderType.toBankCard,
                requisites: menuStore.menu.data.paymentSettings[PaymentProviderType.toBankCard].requisites
            })
        } else if (checkoutStore.paymentType === PaymentProviderType.companyInvoice) {
            checkoutStore.setPaymentDetails({
                type: PaymentProviderType.companyInvoice,
                recipientCompanyCard: {
                    type: RecipientType.russianOOOCard,
                    legalAddress: "",
                    contractId: "",
                    inn: "",
                    kpp: "",
                    shortTitle: ""
                }
            })
        } else if (checkoutStore.paymentType === PaymentProviderType.offline) {
            checkoutStore.setPaymentDetails({
                type: PaymentProviderType.offline,
                method: null,
                changeFromAmount: null
            })
        } else if (checkoutStore.paymentType === PaymentProviderType.cloudpayments) {
            checkoutStore.setPaymentDetails({
                type: PaymentProviderType.cloudpayments
            })
        } else if (checkoutStore.paymentType === PaymentProviderType.sbpTochka) {
            checkoutStore.setPaymentDetails({
                type: PaymentProviderType.sbpTochka
            })
        }
    }, [checkoutStore.paymentType])

    return disabledBlockForBranches.includes(organizationBranchId) ? <></> : <FadeInOutVertical>
        <>
            <p className={style.sectionTitle}>
                {t("cart:choosePaymentType")}
            </p>
            { hasCloudpayments &&
                <div className={styles.radioButtonGroup}>
                    <input
                        type={'radio'}
                        checked={checkoutStore.paymentType === PaymentProviderType.cloudpayments}
                        value={PaymentProviderType.cloudpayments}
                        className={styles.radioInput}
                        id={PaymentProviderType.cloudpayments}
                        onChange={() => {
                            checkoutStore.setPaymentType(PaymentProviderType.cloudpayments)
                        }}
                    />
                    <label
                        htmlFor={PaymentProviderType.cloudpayments}
                        className={styles.radioLabel}
                    >
                        <svg className={styles.onlineSvg} width="44" height="45" viewBox="0 0 44 45" fill="none"
                             xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M15.9678 41.3708H10.1614C9.96886 41.3708 9.78425 41.4473 9.64813 41.5834C9.51202 41.7195 9.43555 41.9042 9.43555 42.0967C9.43555 42.2892 9.51202 42.4738 9.64813 42.6099C9.78425 42.746 9.96886 42.8225 10.1614 42.8225H15.9678C16.1603 42.8225 16.3449 42.746 16.481 42.6099C16.6171 42.4738 16.6936 42.2892 16.6936 42.0967C16.6936 41.9042 16.6171 41.7195 16.481 41.5834C16.3449 41.4473 16.1603 41.3708 15.9678 41.3708Z"
                                fill="#E2E2E2"/>
                            <path
                                d="M41.0081 13.7903H26.129V2.54032C26.1283 1.86682 25.8604 1.22111 25.3842 0.744866C24.9079 0.268624 24.2622 0.000744433 23.5887 0H2.54032C1.86682 0.000744433 1.22111 0.268624 0.744865 0.744866C0.268624 1.22111 0.000744433 1.86682 0 2.54032V42.4597C0.000744433 43.1332 0.268624 43.7789 0.744865 44.2551C1.22111 44.7314 1.86682 44.9993 2.54032 45H23.5887C24.2622 44.9993 24.9079 44.7314 25.3842 44.2551C25.8604 43.7789 26.1283 43.1332 26.129 42.4597V31.9355H41.0081C41.6816 31.9347 42.3273 31.6669 42.8035 31.1906C43.2798 30.7144 43.5476 30.0687 43.5484 29.3952V16.3306C43.5476 15.6571 43.2798 15.0114 42.8035 14.5352C42.3273 14.0589 41.6816 13.7911 41.0081 13.7903ZM16.4894 1.45161L16.1265 2.90323H10.0025L9.63962 1.45161H16.4894ZM24.6774 42.4597C24.6772 42.7483 24.5624 43.0251 24.3583 43.2292C24.1542 43.4334 23.8774 43.5481 23.5887 43.5484H2.54032C2.25165 43.5481 1.97487 43.4334 1.77075 43.2292C1.56663 43.0251 1.45185 42.7483 1.45161 42.4597V2.54032C1.45185 2.25165 1.56663 1.97487 1.77075 1.77075C1.97487 1.56663 2.25165 1.45185 2.54032 1.45161H8.14264L8.73145 3.80504C8.7707 3.96206 8.86131 4.10146 8.98887 4.20108C9.11643 4.30069 9.27363 4.35481 9.43548 4.35484H16.6935C16.8554 4.35481 17.0126 4.30069 17.1402 4.20108C17.2677 4.10146 17.3583 3.96206 17.3976 3.80504L17.9864 1.45161H23.5887C23.8774 1.45185 24.1542 1.56663 24.3583 1.77075C24.5624 1.97487 24.6772 2.25165 24.6774 2.54032V42.4597ZM26.129 24.6774H28.3064V27.5806H26.129V24.6774ZM42.0968 29.3952C42.0965 29.6838 41.9818 29.9606 41.7776 30.1647C41.5735 30.3689 41.2967 30.4836 41.0081 30.4839H26.129V29.0323H29.0323C29.2248 29.0323 29.4094 28.9558 29.5455 28.8197C29.6816 28.6836 29.7581 28.4989 29.7581 28.3065V23.9516C29.7581 23.7591 29.6816 23.5745 29.5455 23.4384C29.4094 23.3023 29.2248 23.2258 29.0323 23.2258H26.129V21.0484H42.0968V29.3952ZM42.0968 19.5968H26.129V18.1452H42.0968V19.5968ZM42.0968 16.6935H26.129V15.2419H41.0081C41.2967 15.2422 41.5735 15.357 41.7776 15.5611C41.9818 15.7652 42.0965 16.042 42.0968 16.3306V16.6935Z"
                                fill="#E2E2E2"/>
                            <path
                                d="M39.9194 23.2258H33.3872C33.1947 23.2258 33.0101 23.3023 32.874 23.4384C32.7378 23.5745 32.6614 23.7591 32.6614 23.9516C32.6614 24.1441 32.7378 24.3287 32.874 24.4649C33.0101 24.601 33.1947 24.6774 33.3872 24.6774H39.9194C40.1119 24.6774 40.2965 24.601 40.4327 24.4649C40.5688 24.3287 40.6452 24.1441 40.6452 23.9516C40.6452 23.7591 40.5688 23.5745 40.4327 23.4384C40.2965 23.3023 40.1119 23.2258 39.9194 23.2258Z"
                                fill="#E2E2E2"/>
                            <path
                                d="M39.9194 25.4033H33.3872C33.1947 25.4033 33.0101 25.4798 32.874 25.6159C32.7378 25.752 32.6614 25.9366 32.6614 26.1291C32.6614 26.3216 32.7378 26.5062 32.874 26.6424C33.0101 26.7785 33.1947 26.8549 33.3872 26.8549H39.9194C40.1119 26.8549 40.2965 26.7785 40.4327 26.6424C40.5688 26.5062 40.6452 26.3216 40.6452 26.1291C40.6452 25.9366 40.5688 25.752 40.4327 25.6159C40.2965 25.4798 40.1119 25.4033 39.9194 25.4033Z"
                                fill="##E2E2E2"/>
                            <path
                                d="M39.9193 27.5806H37.0161C36.8236 27.5806 36.639 27.657 36.5029 27.7931C36.3668 27.9293 36.2903 28.1139 36.2903 28.3064C36.2903 28.4989 36.3668 28.6835 36.5029 28.8196C36.639 28.9557 36.8236 29.0322 37.0161 29.0322H39.9193C40.1118 29.0322 40.2964 28.9557 40.4325 28.8196C40.5687 28.6835 40.6451 28.4989 40.6451 28.3064C40.6451 28.1139 40.5687 27.9293 40.4325 27.7931C40.2964 27.657 40.1118 27.5806 39.9193 27.5806Z"
                                fill="#E2E2E2"/>
                            <path
                                d="M13.0644 13.7903C11.3418 13.7903 9.65788 14.3011 8.22558 15.2581C6.79328 16.2152 5.67694 17.5754 5.01772 19.1669C4.35851 20.7584 4.18603 22.5096 4.52209 24.1991C4.85816 25.8886 5.68768 27.4406 6.90575 28.6586C8.12382 29.8767 9.67573 30.7062 11.3652 31.0423C13.0548 31.3783 14.806 31.2059 16.3975 30.5466C17.989 29.8874 19.3492 28.7711 20.3062 27.3388C21.2633 25.9065 21.7741 24.2226 21.7741 22.5C21.7715 20.1908 20.853 17.977 19.2202 16.3442C17.5874 14.7113 15.3736 13.7929 13.0644 13.7903ZM13.0644 29.758C11.6289 29.758 10.2256 29.3323 9.03205 28.5348C7.83847 27.7373 6.90819 26.6037 6.35884 25.2775C5.80949 23.9513 5.66576 22.4919 5.94581 21.084C6.22587 19.6761 6.91713 18.3828 7.93219 17.3677C8.94725 16.3527 10.2405 15.6614 11.6484 15.3814C13.0564 15.1013 14.5157 15.245 15.842 15.7944C17.1682 16.3437 18.3018 17.274 19.0993 18.4676C19.8968 19.6612 20.3225 21.0644 20.3225 22.5C20.3203 24.4242 19.5549 26.2691 18.1942 27.6298C16.8336 28.9904 14.9887 29.7558 13.0644 29.758Z"
                                fill="#E2E2E2"/>
                            <path
                                d="M16.9062 19.8093L12.2706 24.4448L9.87101 22.6451C9.71701 22.5296 9.52344 22.48 9.33288 22.5072C9.14232 22.5344 8.97038 22.6363 8.85488 22.7903C8.73938 22.9442 8.68979 23.1378 8.71701 23.3284C8.74424 23.5189 8.84605 23.6909 9.00004 23.8064L11.9033 25.9838C12.043 26.0886 12.2159 26.1395 12.3902 26.1272C12.5645 26.1148 12.7284 26.0399 12.852 25.9164L17.9326 20.8357C18.0688 20.6996 18.1452 20.515 18.1452 20.3225C18.1452 20.13 18.0688 19.9454 17.9326 19.8093C17.7965 19.6732 17.6119 19.5967 17.4194 19.5967C17.2269 19.5967 17.0423 19.6732 16.9062 19.8093Z"
                                fill="#E2E2E2"/>
                        </svg>
                        <div className={styles.paymentType}>
                            <p>{//@ts-ignore
                                t(`cart:paymentType.CloudPaymentsCheckout`)}</p>
                            <SmallGreyText>{//@ts-ignore
                                t(`cart:paymentTypeDescription.CloudPaymentsCheckout`)}</SmallGreyText>
                            <div className={styles.paySystems}>
                                {paymentSettings[PaymentProviderType.sbpTochka]?.isEnabled &&
                                    <img src={sbpIcon} alt=""/>
                                }
                                {paymentSettings[PaymentProviderType.cloudpayments].isEnabled &&
                                    <>
                                        <img src={applePayIcon} alt=""/>
                                        <img src={googlePayIcon} alt=""/>
                                    </>
                                }
                            </div>
                        </div>
                    </label>
                </div>
            }

            { hasSBP && !hasCloudpayments &&
				<div className={styles.radioButtonGroup}>
					<input
						type={'radio'}
						checked={checkoutStore.paymentType === PaymentProviderType.sbpTochka}
						value={PaymentProviderType.sbpTochka}
						className={styles.radioInput}
						id={PaymentProviderType.sbpTochka}
						onChange={() => {
                            checkoutStore.setPaymentType(PaymentProviderType.sbpTochka)
                        }}
					/>
					<label
						htmlFor={PaymentProviderType.sbpTochka}
						className={styles.radioLabel}
					>
						<svg className={styles.onlineSvg} width="44" height="45" viewBox="0 0 44 45" fill="none"
							 xmlns="http://www.w3.org/2000/svg">
							<path
								d="M15.9678 41.3708H10.1614C9.96886 41.3708 9.78425 41.4473 9.64813 41.5834C9.51202 41.7195 9.43555 41.9042 9.43555 42.0967C9.43555 42.2892 9.51202 42.4738 9.64813 42.6099C9.78425 42.746 9.96886 42.8225 10.1614 42.8225H15.9678C16.1603 42.8225 16.3449 42.746 16.481 42.6099C16.6171 42.4738 16.6936 42.2892 16.6936 42.0967C16.6936 41.9042 16.6171 41.7195 16.481 41.5834C16.3449 41.4473 16.1603 41.3708 15.9678 41.3708Z"
								fill="#E2E2E2"/>
							<path
								d="M41.0081 13.7903H26.129V2.54032C26.1283 1.86682 25.8604 1.22111 25.3842 0.744866C24.9079 0.268624 24.2622 0.000744433 23.5887 0H2.54032C1.86682 0.000744433 1.22111 0.268624 0.744865 0.744866C0.268624 1.22111 0.000744433 1.86682 0 2.54032V42.4597C0.000744433 43.1332 0.268624 43.7789 0.744865 44.2551C1.22111 44.7314 1.86682 44.9993 2.54032 45H23.5887C24.2622 44.9993 24.9079 44.7314 25.3842 44.2551C25.8604 43.7789 26.1283 43.1332 26.129 42.4597V31.9355H41.0081C41.6816 31.9347 42.3273 31.6669 42.8035 31.1906C43.2798 30.7144 43.5476 30.0687 43.5484 29.3952V16.3306C43.5476 15.6571 43.2798 15.0114 42.8035 14.5352C42.3273 14.0589 41.6816 13.7911 41.0081 13.7903ZM16.4894 1.45161L16.1265 2.90323H10.0025L9.63962 1.45161H16.4894ZM24.6774 42.4597C24.6772 42.7483 24.5624 43.0251 24.3583 43.2292C24.1542 43.4334 23.8774 43.5481 23.5887 43.5484H2.54032C2.25165 43.5481 1.97487 43.4334 1.77075 43.2292C1.56663 43.0251 1.45185 42.7483 1.45161 42.4597V2.54032C1.45185 2.25165 1.56663 1.97487 1.77075 1.77075C1.97487 1.56663 2.25165 1.45185 2.54032 1.45161H8.14264L8.73145 3.80504C8.7707 3.96206 8.86131 4.10146 8.98887 4.20108C9.11643 4.30069 9.27363 4.35481 9.43548 4.35484H16.6935C16.8554 4.35481 17.0126 4.30069 17.1402 4.20108C17.2677 4.10146 17.3583 3.96206 17.3976 3.80504L17.9864 1.45161H23.5887C23.8774 1.45185 24.1542 1.56663 24.3583 1.77075C24.5624 1.97487 24.6772 2.25165 24.6774 2.54032V42.4597ZM26.129 24.6774H28.3064V27.5806H26.129V24.6774ZM42.0968 29.3952C42.0965 29.6838 41.9818 29.9606 41.7776 30.1647C41.5735 30.3689 41.2967 30.4836 41.0081 30.4839H26.129V29.0323H29.0323C29.2248 29.0323 29.4094 28.9558 29.5455 28.8197C29.6816 28.6836 29.7581 28.4989 29.7581 28.3065V23.9516C29.7581 23.7591 29.6816 23.5745 29.5455 23.4384C29.4094 23.3023 29.2248 23.2258 29.0323 23.2258H26.129V21.0484H42.0968V29.3952ZM42.0968 19.5968H26.129V18.1452H42.0968V19.5968ZM42.0968 16.6935H26.129V15.2419H41.0081C41.2967 15.2422 41.5735 15.357 41.7776 15.5611C41.9818 15.7652 42.0965 16.042 42.0968 16.3306V16.6935Z"
								fill="#E2E2E2"/>
							<path
								d="M39.9194 23.2258H33.3872C33.1947 23.2258 33.0101 23.3023 32.874 23.4384C32.7378 23.5745 32.6614 23.7591 32.6614 23.9516C32.6614 24.1441 32.7378 24.3287 32.874 24.4649C33.0101 24.601 33.1947 24.6774 33.3872 24.6774H39.9194C40.1119 24.6774 40.2965 24.601 40.4327 24.4649C40.5688 24.3287 40.6452 24.1441 40.6452 23.9516C40.6452 23.7591 40.5688 23.5745 40.4327 23.4384C40.2965 23.3023 40.1119 23.2258 39.9194 23.2258Z"
								fill="#E2E2E2"/>
							<path
								d="M39.9194 25.4033H33.3872C33.1947 25.4033 33.0101 25.4798 32.874 25.6159C32.7378 25.752 32.6614 25.9366 32.6614 26.1291C32.6614 26.3216 32.7378 26.5062 32.874 26.6424C33.0101 26.7785 33.1947 26.8549 33.3872 26.8549H39.9194C40.1119 26.8549 40.2965 26.7785 40.4327 26.6424C40.5688 26.5062 40.6452 26.3216 40.6452 26.1291C40.6452 25.9366 40.5688 25.752 40.4327 25.6159C40.2965 25.4798 40.1119 25.4033 39.9194 25.4033Z"
								fill="##E2E2E2"/>
							<path
								d="M39.9193 27.5806H37.0161C36.8236 27.5806 36.639 27.657 36.5029 27.7931C36.3668 27.9293 36.2903 28.1139 36.2903 28.3064C36.2903 28.4989 36.3668 28.6835 36.5029 28.8196C36.639 28.9557 36.8236 29.0322 37.0161 29.0322H39.9193C40.1118 29.0322 40.2964 28.9557 40.4325 28.8196C40.5687 28.6835 40.6451 28.4989 40.6451 28.3064C40.6451 28.1139 40.5687 27.9293 40.4325 27.7931C40.2964 27.657 40.1118 27.5806 39.9193 27.5806Z"
								fill="#E2E2E2"/>
							<path
								d="M13.0644 13.7903C11.3418 13.7903 9.65788 14.3011 8.22558 15.2581C6.79328 16.2152 5.67694 17.5754 5.01772 19.1669C4.35851 20.7584 4.18603 22.5096 4.52209 24.1991C4.85816 25.8886 5.68768 27.4406 6.90575 28.6586C8.12382 29.8767 9.67573 30.7062 11.3652 31.0423C13.0548 31.3783 14.806 31.2059 16.3975 30.5466C17.989 29.8874 19.3492 28.7711 20.3062 27.3388C21.2633 25.9065 21.7741 24.2226 21.7741 22.5C21.7715 20.1908 20.853 17.977 19.2202 16.3442C17.5874 14.7113 15.3736 13.7929 13.0644 13.7903ZM13.0644 29.758C11.6289 29.758 10.2256 29.3323 9.03205 28.5348C7.83847 27.7373 6.90819 26.6037 6.35884 25.2775C5.80949 23.9513 5.66576 22.4919 5.94581 21.084C6.22587 19.6761 6.91713 18.3828 7.93219 17.3677C8.94725 16.3527 10.2405 15.6614 11.6484 15.3814C13.0564 15.1013 14.5157 15.245 15.842 15.7944C17.1682 16.3437 18.3018 17.274 19.0993 18.4676C19.8968 19.6612 20.3225 21.0644 20.3225 22.5C20.3203 24.4242 19.5549 26.2691 18.1942 27.6298C16.8336 28.9904 14.9887 29.7558 13.0644 29.758Z"
								fill="#E2E2E2"/>
							<path
								d="M16.9062 19.8093L12.2706 24.4448L9.87101 22.6451C9.71701 22.5296 9.52344 22.48 9.33288 22.5072C9.14232 22.5344 8.97038 22.6363 8.85488 22.7903C8.73938 22.9442 8.68979 23.1378 8.71701 23.3284C8.74424 23.5189 8.84605 23.6909 9.00004 23.8064L11.9033 25.9838C12.043 26.0886 12.2159 26.1395 12.3902 26.1272C12.5645 26.1148 12.7284 26.0399 12.852 25.9164L17.9326 20.8357C18.0688 20.6996 18.1452 20.515 18.1452 20.3225C18.1452 20.13 18.0688 19.9454 17.9326 19.8093C17.7965 19.6732 17.6119 19.5967 17.4194 19.5967C17.2269 19.5967 17.0423 19.6732 16.9062 19.8093Z"
								fill="#E2E2E2"/>
						</svg>
						<div className={styles.paymentType}>
							<p>{//@ts-ignore
                                t(`cart:paymentType.CloudPaymentsCheckout`)}</p>
							<SmallGreyText>{//@ts-ignore
                                t(`cart:paymentTypeDescription.CloudPaymentsCheckout`)}</SmallGreyText>
							<div className={styles.paySystems}>
                                {paymentSettings[PaymentProviderType.sbpTochka]?.isEnabled &&
									<img src={sbpIcon} alt=""/>
                                }
							</div>
						</div>
					</label>
				</div>
            }


            {
                paymentSettings[PaymentProviderType.offline].isEnabled &&  <div className={styles.radioButtonGroup}>
					<input
						type={'radio'}
						checked={checkoutStore.paymentType === PaymentProviderType.offline}
						value={PaymentProviderType.offline}
						className={styles.radioInput}
						id={PaymentProviderType.offline}
						onChange={() => {
                            checkoutStore.setPaymentType(PaymentProviderType.offline)
                        }}
					/>
					<label
						htmlFor={PaymentProviderType.offline}
						className={styles.radioLabel}
					>
						<svg width="44" height="44" viewBox="0 0 44 44" fill="none"
							 xmlns="http://www.w3.org/2000/svg">
							<path
								d="M41.9994 22.1845V16.0004C41.9994 13.9035 40.3729 12.1981 38.3178 12.0327L32.5748 2.00162C32.0426 1.07388 31.1832 0.4108 30.1549 0.13546C29.1314 -0.138004 28.0612 0.00561882 27.1452 0.538766L7.45769 12.0005H3.99997C1.79397 12.0005 0 13.7943 0 16.0004V40C0 42.206 1.79388 44 3.99997 44H37.9994C40.2054 44 41.9994 42.2061 41.9994 40V33.8159C43.1609 33.4017 43.9993 32.3022 43.9993 31.0002V25.0003C43.9993 23.6983 43.1609 22.5987 41.9994 22.1845ZM35.9939 12.0005H27.278L33.815 8.19464L35.9939 12.0005ZM32.8213 6.45908L23.3032 12.0005H19.3551L31.8342 4.73495L32.8213 6.45908ZM28.1519 2.26721C28.6041 2.00256 29.1323 1.93224 29.6373 2.06705C30.148 2.20374 30.5738 2.53383 30.8385 2.99573L30.8405 2.99938L15.3805 12.0005H11.4326L28.1519 2.26721ZM39.9994 40C39.9994 41.1025 39.1019 42 37.9994 42H3.99997C2.89748 42 2.00003 41.1025 2.00003 40V16.0004C2.00003 14.8979 2.89748 14.0005 3.99997 14.0005H37.9994C39.1019 14.0005 39.9994 14.8979 39.9994 16.0004V22.0003H33.9995C30.6909 22.0003 27.9996 24.6917 27.9996 28.0002C27.9996 31.3088 30.6909 34.0001 33.9995 34.0001H39.9994V40V40ZM41.9994 31.0002C41.9994 31.5519 41.5512 32.0002 40.9994 32.0002H33.9995C31.7935 32.0002 29.9995 30.2063 29.9995 28.0002C29.9995 25.7942 31.7934 24.0003 33.9995 24.0003H40.9994C41.5511 24.0003 41.9994 24.4485 41.9994 25.0003V31.0002V31.0002Z"
								fill="#E2E2E2"/>
							<path
								d="M33.9994 26.0002C32.897 26.0002 31.9995 26.8977 31.9995 28.0002C31.9995 29.1027 32.897 30.0001 33.9994 30.0001C35.1019 30.0001 35.9994 29.1027 35.9994 28.0002C35.9995 26.8977 35.102 26.0002 33.9994 26.0002Z"
								fill="#E2E2E2"/>
						</svg>
						<div className={styles.paymentType}>
							<p>{t(`cart:paymentType.Offline`)}</p>
							<SmallGreyText>{t(`cart:paymentTypeDescription.Offline`)}
                            </SmallGreyText>
						</div>
					</label>
				</div>
            }
            {
                checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice && <FadeInOutVertical>

                    <PaperBlock>
                        <p className={style.deliverySettingsTitle}>
                            {t("cart:choosePaymentType")}
                        </p>
                        <div key={RecipientType.russianOOOCard} className={styles.radioButtonGroup}>
                            <input
                                type={'radio'}
                                checked={checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianOOOCard}
                                value={RecipientType.russianOOOCard}
                                className={styles.radioInput}
                                id={RecipientType.russianOOOCard}
                                onChange={() => {
                                    if (!checkoutStore.paymentDetails) return;
                                    if (checkoutStore.paymentDetails.type !== PaymentProviderType.companyInvoice) return;
                                    if (checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianOOOCard) return;

                                    checkoutStore.setPaymentDetails({
                                        ...checkoutStore.paymentDetails,
                                        recipientCompanyCard: {
                                            inn: checkoutStore.paymentDetails.recipientCompanyCard.inn,
                                            legalAddress: checkoutStore.paymentDetails.recipientCompanyCard.legalAddress,
                                            shortTitle: checkoutStore.paymentDetails.recipientCompanyCard.shortTitle,
                                            contractId: checkoutStore.paymentDetails.recipientCompanyCard.contractId,
                                            type: RecipientType.russianOOOCard,
                                            kpp: "",
                                        }
                                    } as CompanyBankAccountRequisites)
                                }}
                            />
                            <label
                                htmlFor={RecipientType.russianOOOCard}
                                className={styles.radioLabel}
                            >
                                {
                                    t(`cart:companyType.russianOOO`)
                                }
                            </label>
                        </div>
                        <div key={RecipientType.russianIPCard} className={styles.radioButtonGroup}>
                            <input
                                type={'radio'}
                                checked={checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianIPCard}
                                value={RecipientType.russianIPCard}
                                className={styles.radioInput}
                                id={RecipientType.russianIPCard}
                                onChange={() => {

                                    if (!checkoutStore.paymentDetails) return;
                                    if (checkoutStore.paymentDetails.type !== PaymentProviderType.companyInvoice) return;
                                    if (checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianIPCard) return;

                                    checkoutStore.setPaymentDetails({
                                        ...checkoutStore.paymentDetails,
                                        recipientCompanyCard: {
                                            inn: checkoutStore.paymentDetails.recipientCompanyCard.inn,
                                            legalAddress: checkoutStore.paymentDetails.recipientCompanyCard.legalAddress,
                                            shortTitle: checkoutStore.paymentDetails.recipientCompanyCard.shortTitle,
                                            contractId: checkoutStore.paymentDetails.recipientCompanyCard.contractId,
                                            type: RecipientType.russianIPCard,
                                            ogrnip: ""
                                        }
                                    } as CompanyBankAccountRequisites)
                                }}
                            />
                            <label
                                htmlFor={RecipientType.russianIPCard}
                                className={styles.radioLabel}
                            >
                                {
                                    t(`cart:companyType.IP`)
                                }

                            </label>
                        </div>
                        <br/>

                        <div>
                            <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <span>{t("cart:paymentDetails.shortTitle")}</span>
                                </div>
                            </p>
                            <div>
                                <input
                                    className={style.deliverySettingsAddressInput}
                                    value={checkoutStore.paymentDetails.recipientCompanyCard.shortTitle}
                                    onChange={changeEventHandlerDecorator((value: string) => {
                                        if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                            checkoutStore.setPaymentDetails({
                                                ...checkoutStore.paymentDetails,
                                                recipientCompanyCard: {
                                                    ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                    shortTitle: value
                                                }
                                            })
                                        }
                                    })}
                                />
                            </div>
                            <br/>
                            <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <span>{t("cart:paymentDetails.inn")}</span>
                                </div>
                            </p>
                            <div>
                                <input
                                    className={style.deliverySettingsAddressInput}
                                    value={checkoutStore.paymentDetails.recipientCompanyCard.inn}
                                    onChange={changeEventHandlerDecorator((value: string) => {
                                        if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                            checkoutStore.setPaymentDetails({
                                                ...checkoutStore.paymentDetails,
                                                recipientCompanyCard: {
                                                    ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                    inn: value
                                                }
                                            })
                                        }
                                    })}
                                />
                            </div>

                            {
                                checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianOOOCard &&
                                <>
                                    <br/>
                                    <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                            <span>{t("cart:paymentDetails.kpp")}</span>
                                        </div>
                                    </p>
                                    <div>
                                        <input
                                            className={style.deliverySettingsAddressInput}
                                            value={checkoutStore.paymentDetails.recipientCompanyCard.kpp}
                                            onChange={changeEventHandlerDecorator((value: string) => {
                                                if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                                    checkoutStore.setPaymentDetails({
                                                        ...checkoutStore.paymentDetails,
                                                        recipientCompanyCard: {
                                                            ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                            kpp: value
                                                        } as RecipientRussianOOOCard
                                                    })
                                                }
                                            })}
                                        />
                                    </div>
                                </>
                            }
                            {
                                checkoutStore.paymentDetails.recipientCompanyCard.type === RecipientType.russianIPCard &&
                                <>
                                    <br/>
                                    <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                        <div style={{display: "flex", justifyContent: "space-between"}}>
                                            <span>{t("cart:paymentDetails.orgnip")}</span>
                                        </div>
                                    </p>
                                    <div>
                                        <input
                                            className={style.deliverySettingsAddressInput}
                                            value={checkoutStore.paymentDetails.recipientCompanyCard.ogrnip}
                                            onChange={changeEventHandlerDecorator((value: string) => {
                                                if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                                    checkoutStore.setPaymentDetails({
                                                        ...checkoutStore.paymentDetails,
                                                        recipientCompanyCard: {
                                                            ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                            ogrnip: value
                                                        } as RecipientRussianIPCard
                                                    })
                                                }
                                            })}
                                        />
                                    </div>
                                </>
                            }
                            <br/>
                            <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <span>{t("cart:paymentDetails.legalAddress")}</span>
                                </div>
                            </p>
                            <div>
                                <input
                                    className={style.deliverySettingsAddressInput}
                                    value={checkoutStore.paymentDetails.recipientCompanyCard.legalAddress}
                                    onChange={changeEventHandlerDecorator((value: string) => {
                                        if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                            checkoutStore.setPaymentDetails({
                                                ...checkoutStore.paymentDetails,
                                                recipientCompanyCard: {
                                                    ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                    legalAddress: value
                                                }
                                            })
                                        }
                                    })}
                                />
                            </div>
                            <br/>
                            <p className={style.deliverySettingsTitle} style={{marginTop: 20}}>
                                <div style={{display: "flex", justifyContent: "space-between"}}>
                                    <span>{t("cart:paymentDetails.contractId")}</span>
                                </div>
                            </p>
                            <div>
                                <input
                                    className={style.deliverySettingsAddressInput}
                                    value={checkoutStore.paymentDetails.recipientCompanyCard.contractId}
                                    onChange={changeEventHandlerDecorator((value: string) => {
                                        if (checkoutStore.paymentDetails?.type === PaymentProviderType.companyInvoice) {
                                            checkoutStore.setPaymentDetails({
                                                ...checkoutStore.paymentDetails,
                                                recipientCompanyCard: {
                                                    ...(checkoutStore.paymentDetails as CompanyBankAccountRequisites).recipientCompanyCard,
                                                    contractId: value
                                                }
                                            })
                                        }
                                    })}
                                />
                            </div>
                        </div>
                    </PaperBlock>
                </FadeInOutVertical>
            }
        </>
    </FadeInOutVertical>

};


export default observer(PaymentDetailsBlock);
